import {
  Box,
  Columns,
  ColumnsItem,
  Container,
  RowItem,
  Rows,
  Section,
  Title,
  TitleLevels,
  TrilogyColor,
} from '@bytel/trilogy-react-ts';
import BoxBilanCarbone from '@domain/home/bilan-carbone';
import BilanCarboneGraph from '@domain/home/bilan-carbone-graph';
import EmpreinteCarboneTelGraph from '@domain/home/empreinte-carbone-tel-graph';
import EmpreinteCarboneTelephones from '@domain/home/empreinte-carbone-tel';
import BoxConfigurationMobile from '@domain/home/box-configuration-mobile';
import BoxContentNavigation from '@shared/components/navigation-box-content';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useData from './hook';
import './style.css';

const Home: React.FC = () => {
  const { t } = useTranslation('domain/home', {
    keyPrefix: 'page',
  });

  const { buttons, isShowIndicators, dataConsommation, dataEmpreintes } = useData();

  return (
    <Container className="is-fullwidth has-background-grey-light homePageContainer" data-cy="home-container">
      <Box className="is-radiusless is-marginless" background={TrilogyColor.GREY_LIGHT} shadowless>
        <Title
          style={{ cursor: 'default', pointerEvents: 'none' }}
          level={TitleLevels.ONE}
          className="has-text-secondary has-text-centered"
          data-cy="home-header-title"
        >
          {t('titre')}
        </Title>
      </Box>

      <Section data-cy="home-container-section-1" background={TrilogyColor.GREY_LIGHT}>
        <Rows data-cy="home-rows-main">
          <RowItem data-cy="home-row-flotte">
            <Columns>
              <ColumnsItem size={8} data-cy="home-box-consommation">
                <BilanCarboneGraph data={dataConsommation} />
              </ColumnsItem>
              <ColumnsItem size={4} data-cy="home-box-bilan-carbone">
                <BoxBilanCarbone data={dataConsommation} />
              </ColumnsItem>
            </Columns>
          </RowItem>
          <RowItem data-cy="home-row-telephones">
            <Columns>
              <ColumnsItem size={6} data-cy="home-box-telephones-achetes">
                <EmpreinteCarboneTelephones data={dataEmpreintes} />
              </ColumnsItem>
              <ColumnsItem size={6} data-cy="home-box-consommation-achat">
                <EmpreinteCarboneTelGraph data={dataEmpreintes} />
              </ColumnsItem>
            </Columns>
          </RowItem>
          <RowItem data-cy="home-row-indicators">
            {isShowIndicators && (
              <Container
                className="is-fullwidth has-background-white indicators-container"
                data-cy="home-indicators-container"
              >
                <RowItem className="" data-cy="home-row-configuration-mobile">
                  <BoxConfigurationMobile />
                </RowItem>
                <RowItem className="" data-cy="home-row-navigation-buttons">
                  <Columns>
                    {buttons.map(({ dataCy, titre, routeRef, count, iconName }) => (
                      <ColumnsItem key={dataCy} className="is-flex is-fullheigth">
                        <BoxContentNavigation
                          dataCy={dataCy}
                          titre={titre}
                          routeRef={routeRef}
                          count={count}
                          iconName={iconName}
                        />
                      </ColumnsItem>
                    ))}
                  </Columns>
                </RowItem>
              </Container>
            )}
          </RowItem>
        </Rows>
      </Section>
    </Container>
  );
};

export default Home;
